import {
    registration,
    registrationApplication,
    registrationApprovalPending,
    registrationConfirmEmail,
    registrationDeclined,
    registrationInterests,
    registrationLocalCommunitySelect,
    registrationMembership,
    registrationMembershipUpgrade,
    registrationPhoto,
    start,
} from '@routes/catalog'
import { useCallback } from 'react'
import { useINAppRouter } from '@routes/utils/useINAppRouter'
import { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export const STEP_MAP = {
    basic_registration: registration,
    application_pending: registrationApplication,
    approval_pending: registrationApprovalPending,
    localcommunity_selection: registrationLocalCommunitySelect,
    email_unconfirmed: registrationConfirmEmail,
    declined: registrationDeclined,
    registered: registrationPhoto,
    photo_submitted: registrationInterests,
    interests_submitted: registrationMembership,
    membership_upgrade: registrationMembershipUpgrade,
    end: start,
} as const

export const isInStepMap = (moveTo: string | null | undefined): moveTo is keyof typeof STEP_MAP =>
    moveTo != null && moveTo in STEP_MAP

export const FALLBACK_ROUTE = start

const moveToWorkflowStep = (
    moveTo: string | null | undefined,
    go: (route: TRoute, navigationOptions?: NavigateOptions) => void
): void => {
    if (!isInStepMap(moveTo)) {
        go(FALLBACK_ROUTE)
        return
    }

    go(STEP_MAP[moveTo])
}

export const useNavigateWorkflow = (): ((data?: WorkflowData) => void) => {
    const { go } = useINAppRouter()

    return useCallback(
        (data?: WorkflowData) => {
            const { canAccess, moveTo } = data ?? {}

            if (canAccess || moveTo === null) {
                return
            }

            moveToWorkflowStep(moveTo, go)
        },
        [go]
    )
}
